<template>
  <section class="info_map">
    <div v-if="expand.active" class="box_scale">
      <div class="scale">
        <div class="position">
          <div v-for="(item,index) in expand.position"
               class="item" :class="[`i_${index+1}`,`i_${item.type}`]">
            <span>{{ item.name }}</span>
          </div>
          <i v-for="(item,index) in expand.arrow"
             class="arrow" :class="[`a_${index+1}`,`a_${item}`]" />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_info_map',
  data(): DataInterface {
    return {
      expand: {
        active: false,
        position: [
          {
            name: '内蒙古',
            type: 'blue'
          },
          {
            name: '甘肃',
            type: 'blue'
          },
          {
            name: '宁夏',
            type: 'blue'
          },
          {
            name: '贵州',
            type: 'blue'
          },
          {
            name: '成渝',
            type: 'yellow'
          },
          {
            name: '京津冀',
            type: 'yellow'
          },
          {
            name: '长三角',
            type: 'yellow'
          },
          {
            name: '粤港澳大湾区',
            type: 'yellow'
          }
        ],
        arrow: [
          'left', 'left', 'left',
          'right', 'right', 'right'
        ]
      }
    };
  },
  async mounted(): Promise<any> {
    await $FN.WaitTime(0);
    this.expand.active = true;
    this.$nextTick
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planMigrate/';

.spriteDecorate() {
  .bg('@{image}info_decorate.png', 1.59rem*@scale, 1.24rem*@scale);
}

.creatAnimation(am_info_item, {
  0% {
    opacity: 0.5;
    .transform(translate(-50%, -50%));
  }
  50% {
    opacity: 1;
    .transform(translate(-50%, calc(~'-50% - 0.1rem')));
  }
  100% {
    opacity: 0.5;
    .transform(translate(-50%, -50%));
  }
});

.creatAnimation(am_info_arrow_left, {
  0% {
    opacity: 0;
    .transform(translate(calc(~'-50% + 0.75rem'), -50%));
  }
  20% {
    opacity: 1;
    .transform(translate(calc(~'-50% + 0.25rem'), -50%));
  }
  40% {
    opacity: 1;
    .transform(translate(calc(~'-50% - 0.25rem'), -50%));
  }
  60% {
    opacity: 0;
    .transform(translate(calc(~'-50% - 0.75rem'), -50%));
  }
  100% {
    opacity: 0;
    .transform(translate(calc(~'-50% - 0.75rem'), -50%));
  }
});

.creatAnimation(am_info_arrow_right, {
  0% {
    opacity: 0;
    .transform(translate(calc(~'-50% - 0.75rem'), -50%));
  }
  20% {
    opacity: 1;
    .transform(translate(calc(~'-50% - 0.25rem'), -50%));
  }
  40% {
    opacity: 1;
    .transform(translate(calc(~'-50% + 0.25rem'), -50%));
  }
  60% {
    opacity: 0;
    .transform(translate(calc(~'-50% + 0.75rem'), -50%));
  }
  100% {
    opacity: 0;
    .transform(translate(calc(~'-50% + 0.75rem'), -50%));
  }
});

.info_map {
  position: relative;
  height: 4rem;
  margin: @margin 0 0;
  .bg('@{image}info_map.png');
  background-size: cover;
  pointer-events: none;
}

.box_scale {
  height: 100%;
  
  .scale {
    &::before {
      content: '';
      display: block;
      .center();
      z-index: 0;
      .bg('@{image}info_line.png', 7.13rem*@scale, 2.9rem*@scale, true);
    }
  }
}

.position {
  .position(absolute, 50%, auto, auto, 50%);
  width: 0;
  height: 0;
  z-index: 2;
  .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.01'), calc(~'-50% + var(--mouse-y,0px) * -0.01')));
  
  .item {
    .center();
    z-index: 1;
    width: 0;
    height: 0;
    
    .loop(@i) when (@i<=8) {
      &.i_@{i} {
        &::after {
          .animation(am_info_item 5s (-1+@i)*0.3s ease infinite forwards);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &.i_1 {
      top: calc(~'50% - 3rem');
      left: calc(~'50% + 0.15rem');
    }
    
    &.i_2 {
      top: calc(~'50% - 1.95rem');
      left: calc(~'50% - 5.85rem');
    }
    
    &.i_3 {
      top: calc(~'50% - 0.85rem');
      left: calc(~'50% - 2.27rem');
    }
    
    &.i_4 {
      top: calc(~'50% + 2.4rem');
      left: calc(~'50% - 4.4rem');
    }
    
    &.i_5 {
      top: calc(~'50% + 0.52rem');
      left: calc(~'50% - 7.5rem');
    }
    
    &.i_6 {
      top: calc(~'50% - 1.9rem');
      left: calc(~'50% + 4.1rem');
    }
    
    &.i_7 {
      top: calc(~'50% + 0.05rem');
      left: calc(~'50% + 7.5rem');
    }
    
    &.i_8 {
      top: calc(~'50% + 2.9rem');
      left: calc(~'50% + 4.7rem');
    }
    
    &.i_blue {
      &::before {
        background-position: 0.02rem*@scale 0.02rem*@scale;
      }
      
      &::after {
        background-position: -0.52rem*@scale 0.02rem*@scale;
      }
    }
    
    &.i_yellow {
      &::before {
        background-position: 0.02rem*@scale -0.19rem*@scale;
      }
      
      &::after {
        background-position: -1.06rem*@scale 0.02rem*@scale;
      }
    }
    
    &::before,
    &::after {
      content: '';
      display: block;
      .center();
      .spriteDecorate();
    }
    
    &::before {
      width: 0.55rem*@scale;
      height: 0.23rem*@scale;
    }
    
    &::after {
      opacity: 0.5;
      top: calc(~'50% - 0.8rem');
      width: 0.55rem*@scale;
      height: 0.67rem*@scale;
    }
    
    span {
      display: block;
      .position(absolute, 20px*@scale, auto, auto, 50%);
      width: 120px*@scale;
      height: @text*@scale;
      .font(center, @text*@scale, @color_13, @text*@scale, true);
      .transform(translateX(-50%));
    }
  }
  
  .arrow {
    .position(absolute, 50%, auto, auto, 50%);
    z-index: 1;
    width: 0;
    height: 0;
    .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.02'), calc(~'-50% + var(--mouse-y,0px) * -0.02')));
    
    .loop(@i) when (@i<=6) {
      &.a_left.a_@{i} {
        &::before {
          .animation(am_info_arrow_left 5s (-1+@i)*1s linear infinite forwards);
        }
      }
      &.a_right.a_@{i} {
        &::before {
          .animation(am_info_arrow_right 5s (-1+@i)*1s linear infinite forwards);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &.a_1 {
      top: calc(~'50% - 2.7rem');
      left: calc(~'50% - 3rem');
    }
    
    &.a_2 {
      top: calc(~'50% - 0rem');
      left: calc(~'50% + 2.8rem');
    }
    
    &.a_3 {
      top: calc(~'50% + 2rem');
      left: calc(~'50% + 1rem');
    }
    
    &.a_4 {
      top: calc(~'50% - 1.5rem');
      left: calc(~'50% - 0.9rem');
    }
    
    &.a_5 {
      top: calc(~'50% - 0.5rem');
      left: calc(~'50% + 3.5rem');
    }
    
    &.a_6 {
      top: calc(~'50% + 1rem');
      left: calc(~'50% - 1.8rem');
    }
    
    &.a_left {
      &::before {
        width: 1.59rem*@scale;
        height: 0.44rem*@scale;
        background-position: 0.02rem*@scale -0.64rem*@scale;
      }
    }
    
    &.a_right {
      &::before {
        width: 1.3rem*@scale;
        height: 0.16rem*@scale;
        background-position: 0.02rem*@scale -1.1rem*@scale;
      }
    }
    
    &::before {
      content: '';
      display: block;
      .center();
      opacity: 0;
      .spriteDecorate();
    }
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .info_map {
    margin: 0;
    .transform(scale(0.8));
  }
  
  .position {
    .item {
      span {
        top: 15px*@scale;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {

}
</style>